const getISODate = (date: Date): string => {
  const dateISO = date?.toISOString();
  return dateISO?.substr(0, dateISO.indexOf('T'));
};

export default getISODate;
